import { HStack, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function LeadCastDetails({handleCastDrawer, data }) {

  // Utility function to find an item by key
  const findItemValue = (key) => data?.find(item => item.key === key)?.anothervalue || [];

  // Extract relevant film data
  const leadCast = findItemValue("leadCast");
  const leadCastRest = findItemValue("leadCastRest");

  const casts = {
    display: "Cast",
    value: [...leadCast, ...leadCastRest],
  };

  return (
    <HStack gap="5px" mt={"0px !important"}>
      {casts.value?.length > 0 && (
        <Stack
          marginInlineStart="0rem!important"
          gap="0"
          className="mt-0 px-0"
        >
          <HStack className="mt-0 px-0" gap={"5px"} flexWrap="wrap"/* width="max-content" */>
            <Text
              fontSize={{ base: "12px", md: "16px" }}
              fontWeight="700"
              color="black"
            >
              {casts.display}
            </Text>
            {casts.value.map((item, index) => (
              <Text
                key={item?.alias}
                fontSize={{ base: "12px", md: "16px" }}
                fontWeight="400"
                color="color.blue"
                marginInlineStart="0rem!important"
                cursor="pointer"
              >
                {item?.full_name || item?.name}
                {index < casts.value.length - 1 && ","}
              </Text>
            ))}
          </HStack>
        </Stack>
      )}
    </HStack>
  );
}
